import React from 'react';
import Icon from '../../../components/AppIcon';

const AdminTabNavigation = ({ tabs, activeTab, onTabChange }) => {
  return (
    <div className="bg-card rounded-lg border border-border mb-6">
      <div className="overflow-x-auto">
        <div className="flex border-b border-border">
          {tabs?.map((tab) => (
            <button
              key={tab?.id}
              onClick={() => onTabChange(tab?.id)}
              className={`flex items-center gap-2 px-6 py-4 text-sm font-medium transition-colors whitespace-nowrap ${
                activeTab === tab?.id
                  ? 'text-primary border-b-2 border-primary bg-primary/5' :'text-muted-foreground hover:text-foreground hover:bg-muted/50'
              }`}
            >
              <Icon name={tab?.icon} size={18} />
              <span>{tab?.label}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AdminTabNavigation;